import { render, staticRenderFns } from "./ListDetail.vue?vue&type=template&id=b0d3baee"
import script from "./ListDetail.vue?vue&type=script&lang=ts"
export * from "./ListDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports